import React from 'react';
import { GroupUser } from '@clef/shared/types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { IconButton, Typography, VirtualList } from '@clef/client-library';
import { Box, makeStyles } from '@material-ui/core';
import UserProfile from '../components/UserProfile';
import Close from '@material-ui/icons/Close';

const useStyles = makeStyles(() => ({
  dialogContent: {
    minWidth: 500,
  },
}));

const GroupMembersDialog: React.FC<{
  group: GroupUser | null | undefined;
  onClose?: () => void;
}> = props => {
  const { group, onClose } = props;
  const styles = useStyles();
  const open = !!group;
  const members = group?.members || [];

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Typography variant="h2_semibold" maxWidth={400}>
          {t('Group: {{groupName}}', { groupName: group?.name ?? '' })}
        </Typography>
        <Box position="absolute" right={4} top={4}>
          <IconButton id="close-dialog-button" onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent className={styles.dialogContent}>
        <Typography variant="body_medium">
          {t('Members ({{membersCount}})', { membersCount: members.length })}
        </Typography>
        <VirtualList
          dataList={members}
          itemHeight={80}
          containerMaxHeight={350}
          children={item => (
            <Box display="flex" alignItems="center" paddingY={2}>
              <UserProfile item={item} showUserStatus="never" />
            </Box>
          )}
        ></VirtualList>
      </DialogContent>
    </Dialog>
  );
};

export default GroupMembersDialog;
